import {JacksonType} from "@sonner/jackson-service-v2";

@JacksonType("MenuMapItemTO")
export class MenuMapItemTO {

  descricao: string;

  uri: string;
}
